export const allAttachmentsKey =
  process.env.REACT_APP_ALL_ATTACHMENTS_KEY || "allAttachments";

export const allEmailsKey = process.env.REACT_APP_ALL_EMAILS_KEY || "allEmails";

export const allFormsKey = process.env.REACT_APP_ALL_FORMS_KEY || "allForms";

export const allIntegrationsKey =
  process.env.REACT_APP_ALL_INTEGRATIONS_KEY || "allIntegrations";

export const allHistoriesKey =
  process.env.REACT_APP_ALL_HISTORIES_KEY || "allHistories";

export const allMsgsKey = process.env.REACT_APP_ALL_MSGS_KEY || "allMsgs";

export const allOrdersKey = process.env.REACT_APP_ALL_ORDERS_KEY || "allOrders";

export const allQuestionsKey =
  process.env.REACT_APP_ALL_QUESTIONS_KEY || "allQuestions";

export const allTelemetriesKey =
  process.env.REACT_APP_ALL_TELEMETRIES_KEY || "allTelemetries";

export const allTicketsKey =
  process.env.REACT_APP_ALL_TICKETS_KEY || "allTickets";

export const ls = localStorage;

export const menuKey = process.env.REACT_APP_MENU_KEY || "isCollapsed";

export const pathDivider =
  process.env.REACT_APP_PATH_DIVIDER || "CRMCloudWebAPI";

export const projectKey = process.env.REACT_APP_PROJECT_KEY || "projectId";

export const projectVersion =
  process.env.REACT_APP_PROJECT_VERSION || "x.x.x.xxx";

export const softphoneKey =
  process.env.REACT_APP_SOFTPHONE_KEY || "softphoneId";

export const sortByKey = process.env.REACT_APP_SORT_BY_KEY || "sortBy";

export const ss = sessionStorage;

export const statusKey = process.env.REACT_APP_STATUS_KEY || "pauseStatus";

export const stayConnectedKey =
  process.env.REACT_APP_STAY_CONNECTED_KEY || "stayConnected";

export const telemetryErrorKey =
  process.env.REACT_APP_TELEMETRY_ERRORS_KEY || "telemetryErrors";

export const tokenKey = process.env.REACT_APP_TOKEN_KEY || "token";

export const videoBgKey = process.env.REACT_APP_VIDEO_BG_KEY || "videoBg";
